import { React, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faBuilding, faDatabase, faTruck, faFileExcel, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { NavLink, Link } from 'react-router-dom'
import Cookies from 'universal-cookie/es6';
import { Offcanvas } from "react-bootstrap";
import PerfilUsuario from './PerfilUsuario';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500&display=swap');

  :root {
    --nav-bg: #0a0e1a;
    --nav-border: rgba(255,255,255,0.07);
    --accent: #00d4ff;
    --accent2: #0090ff;
    --text-main: #f0f4ff;
    --text-muted: rgba(240,244,255,0.5);
    --pill-bg: rgba(255,255,255,0.06);
    --pill-hover: rgba(0,212,255,0.12);
    --dropdown-bg: #0e1525;
    --dropdown-border: rgba(0,212,255,0.15);
  }

  .rs-navbar {
    position: sticky;
    top: 0;
    z-index: 999;
    background: var(--nav-bg);
    border-bottom: 1px solid var(--nav-border);
    font-family: 'DM Sans', sans-serif;
    backdrop-filter: blur(12px);
    padding: 0 24px;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .rs-navbar::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, var(--accent), transparent);
    opacity: 0.4;
  }

  /* Brand */
  .rs-brand {
    font-family: 'Syne', sans-serif;
    font-weight: 800;
    font-size: 15px;
    letter-spacing: 0.12em;
    color: var(--text-main) !important;
    text-decoration: none !important;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }
  .rs-brand-dot {
    width: 8px; height: 8px;
    border-radius: 50%;
    background: var(--accent);
    box-shadow: 0 0 8px var(--accent);
    animation: pulse-dot 2.5s infinite;
  }
  @keyframes pulse-dot {
    0%,100% { box-shadow: 0 0 6px var(--accent); }
    50% { box-shadow: 0 0 14px var(--accent), 0 0 28px rgba(0,212,255,0.4); }
  }

  /* Nav links group */
  .rs-nav-links {
    display: flex;
    align-items: center;
    gap: 2px;
    flex: 1;
    justify-content: center;
  }

  .rs-nav-link {
    font-size: 12.5px;
    font-weight: 500;
    letter-spacing: 0.04em;
    color: var(--text-muted) !important;
    text-decoration: none !important;
    padding: 6px 12px;
    border-radius: 8px;
    transition: all 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: none;
    cursor: pointer;
  }
  .rs-nav-link:hover, .rs-nav-link.active {
    color: var(--text-main) !important;
    background: var(--pill-hover);
  }
  .rs-nav-link .nav-icon {
    font-size: 11px;
    color: var(--accent);
    opacity: 0.8;
  }

  /* Dropdown */
  .rs-dropdown {
    position: relative;
  }
  .rs-dropdown-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    font-weight: 500;
    letter-spacing: 0.04em;
    color: var(--text-muted);
    padding: 6px 12px;
    border-radius: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
  }
  .rs-dropdown-trigger:hover, .rs-dropdown.open .rs-dropdown-trigger {
    color: var(--text-main);
    background: var(--pill-hover);
  }
  .rs-dropdown-trigger .chevron {
    font-size: 9px;
    transition: transform 0.2s;
    color: var(--accent);
  }
  .rs-dropdown.open .chevron {
    transform: rotate(180deg);
  }
  .rs-dropdown-menu {
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    min-width: 230px;
    background: var(--dropdown-bg);
    border: 1px solid var(--dropdown-border);
    border-radius: 12px;
    padding: 8px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.5), 0 0 0 1px rgba(0,212,255,0.05);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-6px);
    transition: all 0.2s;
    z-index: 1000;
  }
  .rs-dropdown.open .rs-dropdown-menu {
    opacity: 1;
    pointer-events: all;
    transform: translateY(0);
  }
  .rs-dropdown-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 400;
    color: var(--text-muted);
    padding: 9px 12px;
    border-radius: 8px;
    text-decoration: none !important;
    transition: all 0.15s;
    background: transparent;
    border: none;
    width: 100%;
    cursor: pointer;
    text-align: left;
    letter-spacing: 0.02em;
  }
  .rs-dropdown-item:hover {
    color: var(--text-main);
    background: var(--pill-hover);
  }
  .rs-dropdown-item .di-icon {
    width: 16px;
    text-align: center;
    color: var(--accent);
    font-size: 11px;
    opacity: 0.7;
  }
  .rs-dropdown-divider {
    height: 1px;
    background: var(--nav-border);
    margin: 6px 0;
  }
  .rs-dropdown-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--text-muted);
    padding: 6px 12px 4px;
    opacity: 0.5;
  }

  /* Profile button */
  .rs-profile-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--pill-bg);
    border: 1px solid var(--nav-border);
    border-radius: 30px;
    padding: 6px 14px 6px 8px;
    cursor: pointer;
    transition: all 0.2s;
    color: var(--text-muted);
    font-size: 12.5px;
    font-weight: 500;
    letter-spacing: 0.04em;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .rs-profile-btn:hover {
    background: var(--pill-hover);
    border-color: rgba(0,212,255,0.3);
    color: var(--text-main);
  }
  .rs-profile-avatar {
    width: 28px; height: 28px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--accent2), var(--accent));
    display: flex; align-items: center; justify-content: center;
    font-size: 11px;
    color: #fff;
    font-weight: 700;
  }

  /* Mobile hamburger */
  .rs-hamburger {
    display: none;
    background: transparent;
    border: 1px solid var(--nav-border);
    border-radius: 8px;
    padding: 7px 10px;
    cursor: pointer;
    color: var(--text-muted);
    transition: all 0.2s;
  }
  .rs-hamburger:hover { color: var(--text-main); border-color: rgba(0,212,255,0.3); }

  /* Hide profile label on very small screens */
  .rs-profile-label { white-space: nowrap; }
  @media (max-width: 600px) {
    .rs-navbar { padding: 0 14px; gap: 8px; }
    .rs-brand { font-size: 13px; letter-spacing: 0.08em; }
    .rs-profile-label { display: none; }
    .rs-profile-btn { padding: 5px 8px; gap: 0; }
    .rs-hamburger {
      border-color: rgba(0,212,255,0.35);
      color: var(--text-main);
      padding: 7px 12px;
    }
  }

  /* Mobile drawer */
  .rs-mobile-overlay {
    display: none;
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.7);
    backdrop-filter: blur(4px);
    z-index: 1200;
  }
  .rs-mobile-drawer {
    position: fixed;
    top: 0; left: 0; bottom: 0;
    width: 280px;
    background: var(--nav-bg);
    border-right: 1px solid var(--dropdown-border);
    z-index: 1201;
    padding: 20px 16px;
    overflow-y: auto;
    transform: translateX(-100%);
    transition: transform 0.28s cubic-bezier(0.4,0,0.2,1);
  }
  .rs-mobile-drawer.open { transform: translateX(0); }
  .rs-mobile-overlay.open { display: block; }
  .rs-mobile-brand {
    font-family: 'Syne', sans-serif;
    font-weight: 800;
    font-size: 14px;
    letter-spacing: 0.12em;
    color: var(--text-main);
    display: flex; align-items: center; gap: 10px;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--nav-border);
  }
  .rs-mobile-link {
    display: flex; align-items: center; gap: 10px;
    font-size: 13.5px; color: var(--text-muted);
    text-decoration: none !important;
    padding: 10px 12px; border-radius: 8px;
    transition: all 0.15s; margin-bottom: 2px;
    background: transparent; border: none; width: 100%; cursor: pointer;
    text-align: left;
  }
  .rs-mobile-link:hover { color: var(--text-main); background: var(--pill-hover); }
  .rs-mobile-section { font-size: 10px; font-weight: 700; letter-spacing: 0.1em;
    text-transform: uppercase; color: var(--text-muted); opacity: 0.4;
    padding: 12px 12px 4px; }
  .rs-mobile-close {
    background: transparent; border: none; color: var(--text-muted);
    cursor: pointer; font-size: 16px; position: absolute; top: 18px; right: 16px;
    transition: color 0.15s;
  }
  .rs-mobile-close:hover { color: var(--text-main); }

  @media (max-width: 960px) {
    .rs-nav-links { display: none !important; }
    .rs-hamburger { display: flex !important; }
  }
`;

function Navbar2() {
  const cookies = new Cookies();

  const normalizeRole = (value) => {
    if (value === undefined || value === null) return "";
    const raw = String(value);
    try {
      return decodeURIComponent(raw)
        .replace(/^['\"]|['\"]$/g, "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    } catch (e) {
      return raw
        .replace(/^['\"]|['\"]$/g, "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }
  };

  const rol = normalizeRole(cookies.get("nombre_Rol"));
  const idRol = String(cookies.get("id_rol") || "").trim();

  const [showProfile, setShowProfile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isBasicUser = rol.includes("usuario") || idRol === "1";
  const hasRoleInfo = rol.length > 0 || idRol.length > 0;
  const isAdmin = hasRoleInfo && !isBasicUser;
  const isDC = rol === "administrador datacenter";
  const canSeeControlMenu = !isBasicUser;

  const buildingLinks = [
    { to: "/torre1", label: "TORRE 1" },
    { to: "/torre2", label: "TORRE 2" },
    { to: "/cbb", label: "CBB" },
    { to: "/cbc", label: "CBC" },
  ];

  return (
    <>
      <style>{css}</style>

      <nav className="rs-navbar">
        {/* Brand */}
        <NavLink className="rs-brand" exact to="/inicio">
          <span className="rs-brand-dot" />
          RESERVA DE SALAS
        </NavLink>

        {/* Desktop nav */}
        <div className="rs-nav-links">
          {buildingLinks.map(({ to, label }) => (
            <NavLink key={to} to={to} className="rs-nav-link">
              <FontAwesomeIcon icon={faBuilding} className="nav-icon" />
              {label}
            </NavLink>
          ))}
          {canSeeControlMenu && (
            <NavLink to="/ver" className="rs-nav-link">
              <span className="nav-icon">📋</span>
              Ver Solicitudes
            </NavLink>
          )}

          {canSeeControlMenu && isAdmin && (
            <NavLink to="/gestion" className="rs-nav-link">
              <span className="nav-icon">🛠</span>
              Gestión
            </NavLink>
          )}

          {canSeeControlMenu && isAdmin && (
            <NavLink to="/reporte" className="rs-nav-link">
              <FontAwesomeIcon icon={faFileExcel} className="nav-icon" />
              Reporte
            </NavLink>
          )}
        </div>

        {/* Right: profile + hamburger */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button className="rs-profile-btn" onClick={() => setShowProfile(true)}>
            <div className="rs-profile-avatar">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <span className="rs-profile-label">MI PERFIL</span>
          </button>
          <button className="rs-hamburger" onClick={() => setMobileOpen(true)}>
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </nav>

      {/* ── Mobile Drawer ─────────────────────────────────────────── */}
      <div className={`rs-mobile-overlay${mobileOpen ? ' open' : ''}`} onClick={() => setMobileOpen(false)} />
      <div className={`rs-mobile-drawer${mobileOpen ? ' open' : ''}`}>
        <button className="rs-mobile-close" onClick={() => setMobileOpen(false)}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="rs-mobile-brand">
          <span className="rs-brand-dot" style={{ width: 7, height: 7 }} />
          RESERVA DE SALAS
        </div>

        <div className="rs-mobile-section">Edificios</div>
        {buildingLinks.map(({ to, label }) => (
          <NavLink key={to} to={to} className="rs-mobile-link" onClick={() => setMobileOpen(false)}>
            <FontAwesomeIcon icon={faBuilding} style={{ color: 'var(--accent)', fontSize: 11 }} />
            {label}
          </NavLink>
        ))}
        {canSeeControlMenu && (
          <Link to="/ver" className="rs-mobile-link" onClick={() => setMobileOpen(false)}>📋 Ver Solicitudes</Link>
        )}

        {isDC && <Link to="/visitas" className="rs-mobile-link" onClick={() => setMobileOpen(false)}>🔒 Solicitudes Aceptadas DC</Link>}

        {canSeeControlMenu && isAdmin && <Link to="/gestion" className="rs-mobile-link" onClick={() => setMobileOpen(false)}>🛠 Gestión</Link>}

        {canSeeControlMenu && isAdmin && (
          <NavLink to="/reporte" className="rs-mobile-link" onClick={() => setMobileOpen(false)}>
            <FontAwesomeIcon icon={faFileExcel} style={{ color: 'var(--accent)', fontSize: 11 }} /> Generar Reporte
          </NavLink>
        )}
      </div>

      {/* ── Profile Offcanvas ──────────────────────────────────────── */}
      <Offcanvas show={showProfile} onHide={() => setShowProfile(false)} placement="end">
        <Offcanvas.Header
          closeButton
          style={{ background: '#0a0e1a', borderBottom: '1px solid rgba(255,255,255,0.07)' }}
        >
          <Offcanvas.Title style={{ fontFamily: "'Syne', sans-serif", color: '#f0f4ff', fontWeight: 700, letterSpacing: '0.08em' }}>
            MI PERFIL
          </Offcanvas.Title>
        </Offcanvas.Header>
        <div style={{
          background: '#0a0e1a',
          textAlign: 'center',
          padding: '28px 0 16px',
          borderBottom: '1px solid rgba(255,255,255,0.07)',
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'linear-gradient(135deg, #0090ff, #00d4ff)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, color: '#fff',
            boxShadow: '0 0 24px rgba(0,212,255,0.3)',
          }}>
            <FontAwesomeIcon icon={faUser} />
          </div>
        </div>
        <Offcanvas.Body style={{ background: '#0e1525' }}>
          <PerfilUsuario />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Navbar2;